import { DropDownList } from '@progress/kendo-react-dropdowns'
import React, { useState } from 'react'
import { useEffect } from 'react'
import { GetLocId } from '../../../Services/ComponentBasedServices/xDockReportService'

function DropDownDestinationPort(props) {
    const [destPorts, setDestPorts] = useState([])
    const [destPortValue, setDestPortValue] = useState({
        DESCRIPTION: 'Select SCAC',
    })

    useEffect(() => {
        if (props['destinationDropdownList'])
            setDestPorts(props['destinationDropdownList'])
    }, [])

    useEffect(() => {
        console.log(props)
        let tempDestportValue = destPorts.filter(
            (d) => d['INTLOCID1'] === props['dataItem']['DES_LOC_PORT']
        )[0]
        setDestPortValue(tempDestportValue)
    }, [destPorts, props])

    const handleChange = (e) => {
        if (props.onChange) {
            props.onChange({
                dataIndex: 0,
                dataItem: props.dataItem,
                field: props.field,
                syntheticEvent: e.syntheticEvent,
                value: e.target.value.INTLOCID1,
            })
            
            props.setTimeZone(e.target.value)
        }
    }

    const { dataItem } = props

    return (
        <td>
            {dataItem['inEdit'] === true
                ? destPorts.length > 0 && (
                      <DropDownList
                          value={destPortValue}
                          data={destPorts}
                          textField="DESCRIPTION"
                          onChange={handleChange}
                      />
                  )
                : dataItem['DES_LOC_PORT']}

            {/* <pre>{JSON.stringify(destPorts, null, 2)}</pre> */}
        </td>
    )
}

export default DropDownDestinationPort
